<template>
  <div class="PageHeader">
    <div class="Container">
      <div class="PageHeader-left">
        <img class="PageHeader-priceIc" src="../../assets/ic_market_line.svg" />
        <a href="https://v.systems" target="_blank">
          <span class="PageHeader-opacity">VSYS Price:</span> ${{
            priceText
          }}
          USD <span class="PageHeader-opacity">| Market Cap:</span> ${{
            marketCap
          }}
          USD
          <!-- <span class="PageHeader-opacity">|  TET Price:</span> ${{ TETPriceText }} USD -->
        </a>
      </div>
      <div class="PageHeader-right">
        <!--  <a class="PageHeader-nav" href="https://www.youtube.com/watch?v=4nNrNBcXIbQ&t=3s" target="_blank"><img src="../../assets/ic_video_line.svg"/>Simple Tutorial</a>
        <a class="PageHeader-nav" href="/wiki/vsys-coin-leasing.html" target="_blank"><img src="../../assets/ic_help_line.svg"/>How to participate in minting?</a> -->

        <!-- <div class="scrollCon">
          <div id="scroll_div">
            <div id="scroll_begin">&ensp;Please note that supernodes have different reward schemes. If the interest you earn is less than the required transaction fee (0.1 VSYS), you might not be able to receive any staking rewards from the supernode.&ensp;</div>
          </div>
        </div> -->

        <div class="PageHeader-nav">
          <a
            class="PageHeader-twitter"
            href="https://twitter.com/VSYSCoin"
            target="_blank"
          ></a>
          <a
            class="PageHeader-medium"
            href="https://medium.com/vsystems"
            target="_blank"
          ></a>
          <a
            class="PageHeader-youtube"
            href="https://www.youtube.com/channel/UC3tnJX2dztNKh2yJxFVSDAw"
            target="_blank"
          ></a>
          <a
            class="PageHeader-telegram"
            href="https://t.me/VSYSOfficialGroup"
            target="_blank"
          ></a>
          <a
            class="PageHeader-reddit"
            href="https://www.reddit.com/r/V_SYSTEMS"
            target="_blank"
          ></a>
        </div>

        <!-- <div class="PageHeader-nav">
          <el-dropdown @command="handleLang" trigger="click">
            <span class="el-dropdown-link">
            {{$t('lang.lang')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="kr">한국어</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
        <div class="ts_box">
          <img
            src="../../assets/google_translate.png"
            alt=""
            class="custom_icon"
          />
          <div class="gtranslate" id="google_translate_element"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PageHeader',
  data() {
    return {
      timer: 0,
    };
  },
  created() {
    this.$store.dispatch('global/getPrice');
    // this.$store.dispatch('global/getTETPrice');
    this.$store.dispatch('global/getCurrentSupply');

    this.timer = setInterval(() => {
      this.$store.dispatch('global/getPrice');
      // this.$store.dispatch('global/getTETPrice');
      this.$store.dispatch('global/getCurrentSupply');
    }, 10000);
  },
  mounted() {
    // this.scrollNotice()
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = 0;
    }

    // if(this.timeOut){
    //   clearTimeout(this.timeOut);
    // }
  },
  computed: {
    ...mapState('global', {
      price: 'price',
      supply: 'supply',
      TETPrice: 'TETPrice',
    }),
    priceText() {
      if (this.price > 0) {
        return this.price.toFixed(4);
      }
      return '--';
    },
    marketCap() {
      if (this.price > 0 && this.supply > 0) {
        const result = (this.price * this.supply).toFixed(0);
        return this.toThousands(result);
      }
      return '--';
    },
    TETPriceText() {
      if (this.TETPrice > 0) {
        return this.TETPrice.toFixed(6);
      }
      return '--';
    },
  },
  methods: {
    toThousands(n) {
      let result = '';
      let symbol = '';
      let num = (n || 0).toString();

      if (num.startsWith('-')) {
        symbol = num.substr(0, 1);
        num = num.slice(1);
      }

      const arr = num.split('.');
      let integer = arr[0];
      let decimal = '';

      if (arr.length > 1 && arr[1]) {
        decimal = `.${arr[1]}`;
      }

      while (integer.length > 3) {
        result = `,${integer.slice(-3)}${result}`;
        integer = integer.slice(0, integer.length - 3);
      }

      if (integer) {
        result = integer + result + decimal;
      }

      return symbol + result;
    },
    handleLang(command) {
      this.$i18n.locale = command;
    },
    scrollNotice() {
      const scroll_div = document.getElementById('scroll_div');
      const that = this;
      let step2 = 2;
      function timet() {
        scroll_div.scrollLeft += step2;
        if (step2 > 0 && scroll_div.scrollLeft >= scrollWidth) {
          step2 = -step2;
        } else if (step2 < 0 && scroll_div.scrollLeft <= 0) {
          step2 = -step2;
        }
        that.timeOut = setTimeout(timet, 50);
      }
      if (scroll_div.scrollWidth > scroll_div.offsetWidth) {
        var scrollWidth = scroll_div.scrollWidth - scroll_div.offsetWidth;
        setTimeout(timet, 500);
      } else {
        scroll_div.scrollLeft = 0;
        clearTimeout(that.timeOut);
      }
      scroll_div.onmouseover = function () {
        clearTimeout(that.timeOut);
      };
      scroll_div.onmouseout = function () {
        timet();
      };
    },
  },
};
</script>

<style lang="scss" >
.PageHeader {
  color: white;
  background: black;
  min-width: 1240px;
  a {
    color: white !important;
  }

  &-twitter {
    background: url("../../assets/ic_twitter_white_normal.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &-twitter:hover {
    background: url("../../assets/ic_twitter_white_hover.svg");
  }
  &-medium {
    background: url("../../assets/ic_medium_white_normal.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &-medium:hover {
    background: url("../../assets/ic_medium_white_hover.svg");
  }
  &-youtube {
    background: url("../../assets/ic_youtube_white_normal.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &-youtube:hover {
    background: url("../../assets/ic_youtube_white_hover.svg");
  }
  &-telegram {
    background: url("../../assets/ic_telegram_white_normal.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &-telegram:hover {
    background: url("../../assets/ic_telegram_white_hover.svg");
  }
  &-reddit {
    background: url("../../assets/ic_reddit_white_normal.svg");
    background-size: contain;
    background-repeat: no-repeat;
  }
  &-reddit:hover {
    background: url("../../assets/ic_reddit_white_hover.svg");
  }

  .Container {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
  }
  &-left,
  &-right {
    height: 38px;
    line-height: 38px;
    display: flex;
    align-items: center;
  }
  &-nav {
    display: flex;
    align-items: center;
    a {
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      margin-right: 18px;
      width: 26px;
      height: 26px;
    }
    img {
      margin-right: 8px;
    }
  }
  &-nav + &-nav {
    margin-left: 30px;
  }
  &-priceIc {
    width: 16px;
    margin-right: 8px;
  }
  &-opacity {
    opacity: 0.5;
  }
  .el-dropdown {
    color: white;
  }

  .scrollCon {
    width: 500px;
    border-left: 1px solid rgba(255, 255, 255, 0.4);
    border-right: 1px solid rgba(255, 255, 255, 0.4);
    height: 16px;
  }
  #scroll_div {
    overflow: hidden;
    white-space: nowrap;
    width: 460px;
    margin: 0 auto;
    color: white;
    height: 16px;
    line-height: 16px;
  }
  #scroll_begin {
    display: inline;
  }
}
.ts_box {
  display: flex;
  align-items: center;
  position: relative;

  .custom_icon {
    width: 18px;
    height: 18px;
    position: absolute;
  }

  .gtranslate {
    margin-left: 20px;

    .goog-te-gadget-icon {
      display: none;
    }
  }
}
</style>
